import useAppContext from "../../shared/context/AppContext/useAppContext";

const useAgentData = () => {
  const { userAgentData } = useAppContext();
  return userAgentData;
};

export default useAgentData;
